import { createLoader } from '@meteor/data-hooks';
import { useMemo } from 'react';
import { withAuth } from '../../user';
import { organizationClient } from '../client';
import { useCurrentOrganization } from './organization';

export let flagLoader = createLoader({
  name: 'flag',
  fetch: (i: { organizationId: string }) => withAuth(() => organizationClient.flag.get(i)),
  mutators: {}
});

export let useFlags = () => {
  let org = useCurrentOrganization();
  return flagLoader.use(org.data ? { organizationId: org.data.id } : null);
};

export let useFlag = (flagId: string): any => {
  let flags = useFlags();

  return useMemo(
    // @ts-ignore
    () => flags.data?.flags.find((f: any) => f.flag.slug == flagId)?.value ?? null,
    [flags.data, flagId]
  );
};
